import React from 'react';

const Legends = ({ legendItems, colors }) => {
  const legends = legendItems.map((legend, index) => (
    <span className="custom-legend" key={index}>
      <span className="custom-legend-indicator" style={{ backgroundColor: colors[index] }}></span>
      <span className="custom-legend-text">{legend}</span>
    </span>
  ));

  return legends;
}

export default Legends;


// WEBPACK FOOTER //
// ./src/components/charts/Legends.jsx